export const userFinancialInfoFormDefaultValues = {
  type: '',
  code: { value: '', label: '' },
  account: '',
  account_digit: '',
  agency: '',
  monthly_earn: '',
  property_value: ''
}
